window.addEventListener('load',function () {
    // 选择要观察变动的节点
    const targetNode = document.querySelector('#Collection');
    // 观察器的配置
    const config = { attributes: true, childList:true, subtree:true };
    // 创建一个观察器实例并传入回调函数
    const observer = new MutationObserver(hideEl);
    observer.observe(targetNode, config);
})

function hideEl(){
  const priceSelector = document.querySelectorAll('.price-regular,.price-sale,.special-price,.old-price, .grid-product__price, .price-item');
  const atc = document.querySelectorAll('.action');
  if(priceSelector.length>0){
    for(let i = 0; i<priceSelector.length;i++){
      const price = priceSelector[i].innerText.slice(1);
      if(price.replace(/[^\d\.]/g,'') == 0)
        {
          priceSelector[i].style.display = 'none';
        }
    }
  }
  if(atc.length>0){
    for(let i = 0; i<atc.length;i++){
      atc[i].style.display = 'none';
    }
  }
}